import { whyUseCards } from '@/mocks/categories';

export default function WhyUse() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wider uppercase mb-3">
            Key Benefits
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Why Use Vigorbuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            Discover how organized product research transforms your shopping experience with these powerful benefits.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {whyUseCards.map((card) => (
            <div
              key={card.title}
              className="group p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-accent-200/60 transition-all duration-300"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-accent-50 group-hover:bg-accent-100 transition-colors mb-4">
                <i className={`${card.icon} text-accent-600 text-lg md:text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-base md:text-lg mb-2">
                {card.title}
              </h3>
              <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">
                {card.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}